import { ApolloProvider } from '@apollo/client';
import { CssBaseline } from '@mui/joy';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import { StyledEngineProvider } from '@mui/material';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { NewAuthProvider } from './components/management/NewAuthProvider';
import apolloClient from './technical/graphql/createApollo.ts';
import MaterialTheme from './MaterialTheme';
import './App.css';
import { joyTheme } from './theme/joyTheme';

import VersionChecker from './components/technical/VersionChecker.tsx';
import { initializeAmplify } from './setup/initializeAmplify';

import '@sjmc11/tourguidejs/dist/css/tour.min.css';
import { ApplicationProvider } from 'ApplicationContext.tsx';
import BreakpointTools from 'components/technical/BreakpointTools/BreakpointTools.tsx';
import DevtoolsFormatters from 'technical/DevtoolsFormatters.tsx';
import { CookieColorSchemeUpdater } from 'ColorSchemeManager.ts';
import jsCookie from 'js-cookie';
import RootOutlet from './RootOutlet.tsx';

// Get initial theme from cookie
const getInitialTheme = (): 'light' | 'dark' => {
  const cookieTheme = jsCookie.get('ui-theme');
  return cookieTheme === 'dark' || cookieTheme === 'light' ? cookieTheme : 'light';
};

// Initialize Amplify before rendering the app
initializeAmplify();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <StyledEngineProvider>
      <JoyCssVarsProvider
        theme={joyTheme}
        defaultMode={getInitialTheme()}
        modeStorageKey={undefined}
        colorSchemeStorageKey={undefined}
      >
        <CssBaseline />
        <MaterialTheme>
          <CookieColorSchemeUpdater />
          <ApplicationProvider>
            <ApolloProvider client={apolloClient}>
              <NewAuthProvider>
                <BreakpointTools>
                  <DevtoolsFormatters />
                  <RootOutlet />
                  <VersionChecker />
                </BreakpointTools>
              </NewAuthProvider>
            </ApolloProvider>
          </ApplicationProvider>
        </MaterialTheme>
      </JoyCssVarsProvider>
    </StyledEngineProvider>
  </StrictMode>
);
